export const emojis = [
  "🏰",
  "🚛",
  "🚜",
  "🦯",
  "🦽",
  "🦼",
  "🛴",
  "🚲",
  "🛵",
  "🏍",
  "🛺",
  "🚨",
  "🚔",
  "🚍",
  "🚘",
  "🚖",
  "🛞",
  "🚡",
  "🚠",
  "🚟",
  "🚃",
  "🚋",
  "🚞",
  "🚝",
  "🚄",
  "🚅",
  "🚈",
  "🚂",
  "🚆",
  "🚇",
  "🚊",
  "🚉",
  "✈️",
  "🛫",
  "🛬",
  "🛩",
  "💺",
  "🛰",
  "🚀",
  "🛸",
  "🚁",
  "🛶",
  "⛵️",
  "🚤",
  "🛥",
  "🛳",
  "⛴",
  "🚢",
  "⚓️",
  "🛟",
  "🪝",
  "⛽️",
  "🚧",
  "🚦",
  "🚥",
  "🚏",
  "🗺",
  "🗿",
  "🗽",
  "🗼",
  "🏰",
  "🏯",
  "🏟",
  "🎡",
  "🎢",
  "🛝",
  "🎠",
  "⛲️",
  "⛱",
  "🏖",
  "🏝",
  "🏜",
  "🌋",
  "⛰",
  "🏔",
  "🗻",
  "🏕",
  "⛺️",
  "🛖",
  "🏠",
  "🏡",
  "🏘",
  "🏚",
  "👱‍♂️",
  "👩‍🦳",
  "👲",
  "👳‍♂️",
  "🧕",
  "👮‍♂️",
  "👷‍♀️",
  "💂‍♂️",
  "🕵️‍♀️",
  "👩‍⚕️",
  "🧑‍⚕️",
  "👨‍⚕️",
  "👩‍🌾",
  "👩‍🍳",
  "👩‍🎓",
  "👩‍🎤",
  "🧑‍🎤",
  "👨‍🎤",
  "👩‍🏫",
  "👩‍🏭",
  "👩‍💻",
  "👨‍💼",
  "👩‍🔧",
  "👩‍🔬",
  "👩‍🎨",
  "👩‍🚒",
  "👩‍✈️",
  "👩‍🚀",
  "👨‍⚖️",
  "👰‍♀️",
  "🤵‍♀️",
  "🤵",
  "👸",
  "🥷",
  "🦸‍♀️",
  "🦹‍♀️",
];
export const avatarImg = (avatarIndex: any) => {
  if (!avatarIndex) {
    return emojis[0];
  }
  let numericIndex: number;
  if (typeof avatarIndex === "string" && avatarIndex.startsWith("0x")) {
    numericIndex = parseInt(avatarIndex, 16);
  } else {
    numericIndex = Number(avatarIndex);
  }

  const index = numericIndex % emojis.length;
  return emojis[index];
};

export const unknownEmoji = "💰";

export const consumerEmoji = "👤";

export const avatarFromAddress = (address: string) => {
  if (!address) {
    return emojis[0];
  }
  const lastFour = String(address).slice(-6);
  const num1 = parseInt(lastFour, 16) % emojis.length;
  return emojis[num1];
};
